import { configureStore } from "@reduxjs/toolkit"; 
import Cart from "./cartSlice";
export const Store = configureStore({
    reducer:{
        Cart
    }
}) 